<template>
  <el-collapse v-model="coolerInventory.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="cooler-inventory-search-section" id="cooler-inventory-search-section">
      <el-form
        id="cooler-inventory-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('coolerInventory.dayOfService')" prop="dayOfService">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                @change="handleChangeDate"
                v-model="searchForm.dayOfService"
                format="MM/dd/yyyy"
                type="date"
                id="searchForm-ship-date"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('coolerInventory.shipper')"
              prop="shipperAccountId"
              class="shipper-filter shipper-wrp"
            >
              <autocomplete
                :model.sync="searchForm.shipperAccountId"
                :url="urlShipperAutocomplete"
                labelField="name"
                labelFieldLastWithDash="number"
                :selectAction="handleSearch"
                :enterKeyAction="handleSearch"
                :clearAction="handleSearch"
                :classCss="null"
                valueField="id"
                id="searchForm-shipper"
                ref="search-shipper-list"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('coolerInventory.consignee')">
              <autocomplete
                :model.sync="searchForm.consigneeAccountId"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlConsigneeAutocomplete"
                :selectAction="handleSearch"
                :enterKeyAction="handleSearch"
                :clearAction="handleSearch"
                labelField="name"
                valueField="id"
                id="searchForm-consignee"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$t('coolerInventory.status')"
              prop="status"
              class="title-input">
              <el-select
                v-model="searchForm.status"
                id="searchForm-status"
                ref="filter-status"
                @change="handleSearch">
                <el-option
                  v-for="item in coolerInventoryStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('coolerInventory.fault')"
              prop="status"
              class="title-input">
              <select-list
                @change="handleSearch"
                :value.sync="searchForm.faultId"
                :url="urlFaults"
                :default-all="true"
                label-field="description"
                value-field="id"
                ref="filter-fault-select" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('coolerInventory.disposition')"
              prop="status"
              class="title-input">
              <select-list
                @change="handleSearch"
                :value.sync="searchForm.dispositionId"
                :url="urlDispositions"
                :default-all="true"
                label-field="description"
                value-field="id"
                ref="filter-disposition-select" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('common.search')"
              placement="top-start"
            >
              <el-button
                id="form-search-button"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
                class="button-action-default"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import SelectList from '@/components/Select/SelectList';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'SearchFilters',
  components: { Autocomplete, SelectList },
  computed: {
    ...mapGetters(['coolerInventory'])
  },
  data() {
    return {
      searchForm: {
        dayOfService: new Date(),
        shipperAccountId: null,
        consigneeAccountId: null,
        status: constants.COOLER_INVENTORY.STATUS[0].value,
        faultId: null,
        dispositionId: null
      },
      activeCollapsibleName: ['cooler-inventory-search-section'],
      urlShipperAutocomplete: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      urlConsigneeAutocomplete: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
      urlFaults: apiConstants.END_POINTS.COOLER_INVENTORY.FAULTS,
      urlDispositions: apiConstants.END_POINTS.COOLER_INVENTORY.DISPOSITIONS,
      coolerInventoryStatusOptions: constants.COOLER_INVENTORY.STATUS,
    };
  },
  mounted() {
    this.$store.dispatch('coolerInventory/setDefaultFilters', this.searchForm);
  },
  methods: {
    handleSearch() {
      this.$emit('shipper-changed', this.$refs['search-shipper-list'].getLocalModel());
      this.$store.dispatch('coolerInventory/search', this.searchForm);
    },
    handleChangeDate() {
      this.handleSearch();
    }
  }
};
</script>
